import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  // InputNumber,
  Row,
  TreeSelect,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import {
  createResourceObject,
  updateResourceObject,
} from '../../../../api/admin/permission';
import { messageError, messageSuccess } from '../../../../components/message';
import getFormatMessage from '../../../../locales/get-format-message';
import { IPermissionResourceType } from '../../../../model/api-modules';
import { BaseOptionType, DefaultOptionType } from 'antd/lib/select';
import {
  IServicePermissionsGroupItem,
  // IServicePermissionsObjectItem,
  IServicePermissionsObjectTableItem,
} from '../../../../model';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly row: IServicePermissionsObjectTableItem | null;
  readonly groupList: IServicePermissionsGroupItem[];
  readonly type: IPermissionResourceType;
  readonly getObjectList: () => void;
}

export const ObjectDrawer = (props: IProps) => {
  const [form] = useForm<any>();
  // const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const getModalTitle = () => {
    if (props.type === IPermissionResourceType.Create) {
      return getFormatMessage('create_object');
    }
    return getFormatMessage('edit_object');
  };
  const showSuccessMessage = () => {
    messageSuccess(
      props.type === IPermissionResourceType.Create
        ? getFormatMessage('create_success')
        : getFormatMessage('edit_success')
    );
  };
  const handleOpenCancel = () => {
    form.resetFields();
    props.onClose();
  };
  const handleOpenSubmit = async () => {
    const values = await form.validateFields();
    setLoading(true);
    if (!values) {
      return;
    }
    try {
      const trimmedName = values.objectName.trim();
      const valuesForm = {
        ...values,
        objectName: trimmedName,
      };
      let res;
      // const res={data:[],code:0};
      if (props.type === IPermissionResourceType.Edit && props.row) {
        res = await updateResourceObject({
          objectObjectId: props.row?.objectId,
          // data:[values.data],
          ...valuesForm,
          objectId: props.row?.objectId,
        });
      } else if (props.type === IPermissionResourceType.Create) {
        res = await createResourceObject({
          ...valuesForm,
        });
      }
      if (res) {
        showSuccessMessage();
        if (props.type === IPermissionResourceType.Create) {
          form.setFieldsValue({
            objectName: '',
            objectKey: '',
          });
          props.getObjectList();
        } else {
          handleOpenCancel();
          props.getObjectList();
        }
      } else {
        messageError(getFormatMessage('failed_submit'));
      }
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('failed_submit')
      );
      return false;
    } finally {
      setLoading(false);
    }
  };
  const findChildren = (parentId: number) => {
    const children = props.groupList.filter(
      (item) => item.parentId === parentId
    );
    const newChildren: (BaseOptionType | DefaultOptionType)[] = [];
    children.forEach((child) => {
      const children = findChildren(child.objectGroupId);
      newChildren.push({
        title: child.objectGroupName,
        value: child.objectGroupId,
        children: children.length === 0 ? null : children,
      });
    });
    return newChildren;
  };

  const getGroupTree = () => {
    const rootNodes = findChildren(0);
    return rootNodes || [];
  };

  const dropdownOptions = getGroupTree();
  useEffect(() => {
    if (props.type === IPermissionResourceType.Edit) {
      form.setFieldsValue({
        ...props.row,
      });
    }
    setInit(true);
  }, [props.type]);
  const renderFormItems = () => {
    // const disabled = props.type === IPermissionResourceType.Edit;
    return (
      <>
        <div className="drawer-download-text">
          {/* {props.row?.objectId ? (
            <div className="drawer-download-h" style={{ margin: 10 }}>
              {getFormatMessage('objectGroupId')}:{props.row?.objectGroupId}
            </div>
          ) : null} */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="objectGroupId"
                label={getFormatMessage('objectGroupName')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <TreeSelect treeData={dropdownOptions} treeDefaultExpandAll />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              {/* <Form.Item
                name="objectId"
                label={getFormatMessage('objectId')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <InputNumber></InputNumber>
              </Form.Item> */}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="objectName"
                label={getFormatMessage('objectName')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  placeholder={getFormatMessage('please_enter_object_name')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="objectKey"
                label={getFormatMessage('objectKey')}
                rules={[{ required: true }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  placeholder={getFormatMessage('please_enter_object_key')}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </>
    );
  };

  if (!init) return null;
  return (
    <Drawer
      onClose={() => props.onClose()}
      title={<p className="fail-title">{getModalTitle()}</p>}
      placement="right"
      width={520}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <Button
            className="sub-button"
            onClick={handleOpenCancel}
            disabled={loading}
          >
            {getFormatMessage('cancel')}
          </Button>
          <Button
            className="gc-btn gc-btn-primary gc-btn-download"
            loading={loading}
            onClick={handleOpenSubmit}
          >
            {getFormatMessage('submit')}
          </Button>
        </div>
      }
    >
      <Form form={form}>{renderFormItems()}</Form>
    </Drawer>
  );
};
